// extracted by mini-css-extract-plugin
export default {"titleBlock":"MonitorSectionTitle_titleBlock__u0TYq","title":"MonitorSectionTitle_title__LmEYS","name":"MonitorSectionTitle_name__w2vxL"};